import { Injectable } from '@angular/core';
import { RxStore } from 'shared/domain';

import { Attachment } from '@treetop/shared/model';

@Injectable({ providedIn: 'root' })
export class CurrentSessionResourcesStore {
  currentAssets = new RxStore<Attachment[]>([]);
}
